jQuery(document).ready(function ($) {
    var $form = $('.woocommerce-EditAccountForm.edit-account');
    var $addressSection = $('[data-user-address-book]');

    if (!$form.length) {
        return;
    }

    function syncBlockToggleState($block) {
        var isClosed = $block.hasClass('closed');
        var $toggle = $block.find('.account-edit-block__toggle').first();

        $toggle.attr('aria-expanded', isClosed ? 'false' : 'true');
    }

    function openBlock($block) {
        $block.removeClass('closed');
        syncBlockToggleState($block);
    }

    function closeBlock($block) {
        $block.addClass('closed');
        syncBlockToggleState($block);
    }

    $form.find('.account-edit-block').each(function () {
        syncBlockToggleState($(this));
    });

    $form.on('click', '.account-edit-block__toggle', function (e) {
        e.preventDefault();

        var $block = $(this).closest('.account-edit-block');

        if ($block.hasClass('closed')) {
            openBlock($block);
        } else {
            closeBlock($block);
        }
    });

    function clearFieldErrors($scope) {
        $scope.find('.vet-label').removeClass('is-invalid');
        $scope.find('input, select, textarea').removeClass('is-invalid');
    }

    function renderFieldErrors($scope, errors) {
        clearFieldErrors($scope);

        $.each(errors, function (fieldName, message) {
            var $field = $scope.find('[name="' + fieldName + '"]');

            if (!$field.length) {
                return;
            }

            $field.addClass('is-invalid');
            $field.parent().find('.vet-label').addClass('is-invalid');
        });

        var firstFieldName = Object.keys(errors)[0];

        if (firstFieldName) {
            var $firstInvalid = $scope.find('[name="' + firstFieldName + '"]').first();

            if ($firstInvalid.length) {
                var $parentBlock = $firstInvalid.closest('.account-edit-block');
                if ($parentBlock.length) {
                    openBlock($parentBlock);
                }

                $firstInvalid.trigger('focus');
            }
        }
    }

    function setBlockNotice($block, message, type) {
        var $notice = $block.find('.account-edit-block__notice').first();

        $notice.removeClass('is-success is-error is-loading');

        if (!message) {
            $notice.text('');
            return;
        }

        if (type) {
            $notice.addClass('is-' + type);
        }

        $notice.text(message);
    }

    function setBlockSavingState($block, isSaving) {
        $block.toggleClass('is-saving', isSaving);
        $block.find('button, input:not([readonly]), select, textarea').prop('disabled', isSaving);

        if (isSaving) {
            setBlockNotice($block, user_profile.i18n.saving, 'loading');
        }
    }

    function collectUserInfoData($block) {
        return {
            account_first_name: $.trim($block.find('[name="account_first_name"]').val()),
            account_last_name: $.trim($block.find('[name="account_last_name"]').val()),
            account_email: $.trim($block.find('[name="account_email"]').val()),
            billing_phone: $.trim($block.find('[name="billing_phone"]').val()),
            billing_person_type: $block.find('[name="billing_person_type"]:checked').val() || '',
            billing_country: $block.find('[name="billing_country"]').val() || '',
            billing_user_role: $.trim($block.find('[name="billing_user_role"]').val() || ''),
            billing_address_1: $.trim($block.find('[name="billing_address_1"]').val() || ''),
            billing_address_2: $.trim($block.find('[name="billing_address_2"]').val() || ''),
            billing_city: $.trim($block.find('[name="billing_city"]').val() || ''),
            billing_postcode: $.trim($block.find('[name="billing_postcode"]').val() || ''),
            company_vat_payer: $block.find('[name="company_vat_payer"]:checked').val() || 'no',
            company_name: $.trim($block.find('[name="company_name"]').val() || ''),
            company_reg_nr: $.trim($block.find('[name="company_reg_nr"]').val() || ''),
            company_vat_nr: $.trim($block.find('[name="company_vat_nr"]').val() || ''),
            company_legal_address: $.trim($block.find('[name="company_legal_address"]').val() || ''),
            account_company_bank: $.trim($block.find('[name="account_company_bank"]').val() || ''),
            account_company_bank_account: $.trim($block.find('[name="account_company_bank_account"]').val() || ''),
            billing_cert_number: $.trim($block.find('[name="billing_cert_number"]').val() || '')
        };
    }

    function collectShippingData($block) {
        return {
            shipping_address_1: $.trim($block.find('[name="shipping_address_1"]').val()),
            shipping_address_2: $.trim($block.find('[name="shipping_address_2"]').val()),
            shipping_city: $.trim($block.find('[name="shipping_city"]').val()),
            shipping_postcode: $.trim($block.find('[name="shipping_postcode"]').val()),
            shipping_phone: $.trim($block.find('[name="shipping_phone"]').val()),
            shipping_country: $block.find('[name="shipping_country"]').val() || ''
        };
    }

    function saveUserInfoBlock($block) {
        var data = collectUserInfoData($block);

        clearFieldErrors($block);
        setBlockSavingState($block, true);

        $.ajax({
            type: 'post',
            url: user_profile.ajax_url,
            dataType: 'json',
            data: $.extend({}, data, {
                action: 'vet_save_account_user_info',
                security: user_profile.nonce
            })
        }).done(function (response) {
            if (!response || !response.success) {
                setBlockNotice($block, user_profile.i18n.saveError, 'error');

                return;
            }

            setBlockNotice($block, response.data.message || user_profile.i18n.userInfoSaved, 'success');
        }).fail(function (xhr) {
            var response = xhr.responseJSON;

            if (response && response.data && response.data.field_errors) {
                renderFieldErrors($block, response.data.field_errors);
            }

            setBlockNotice(
                $block,
                response && response.data && response.data.message ? response.data.message : user_profile.i18n.saveError,
                'error'
            );
        }).always(function () {
            setBlockSavingState($block, false);
        });
    }

    function updateDefaultAddressUI(selectedId) {
        $addressSection.find('.custom-address-card').each(function () {
            var $card = $(this);
            var isDefault = $card.attr('data-address-id') === selectedId;

            $card.toggleClass('is-default', isDefault);

            $card.find('.custom-address-card__badge').remove();
            $card.find('.set-default-address-card').remove();

            if (isDefault) {
                $card.find('.custom-address-card__summary-top').append(
                    '<span class="custom-address-card__badge">' + user_profile.i18n.defaultBadge + '</span>'
                );
            } else if ($card.attr('data-is-new') !== '1') {
                addCardSetDefaultButton($card);
            }
        });
    }

    function addCardSetDefaultButton($card) {
        $card.find('.custom-address-card__actions').prepend(
            '<button type="button" class="set-default-address-card">' + user_profile.i18n.setDefault + '</button>'
        );
    }

    function setSectionNotice(message, type) {
        var $notice = $addressSection.find('.custom-addresses-section__notice').first();

        $notice.removeClass('is-success is-error is-loading');

        if (!message) {
            $notice.text('');
            return;
        }

        if (type) {
            $notice.addClass('is-' + type);
        }

        $notice.text(message);
    }

    if ($addressSection.length) {
        var selectors = {
            accordion: '.custom-addresses-accordion',
            card: '.custom-address-card',
            body: '.custom-address-card__body',
            addButton: '.add-new-address',
            toggleButton: '.toggle-address-card',
            saveButton: '.save-address-card',
            cancelButton: '.cancel-address-card',
            deleteButton: '.delete-address-card',
            setDefaultButton: '.set-default-address-card',
            emptyState: '.custom-addresses-empty'
        };

        function closeCard($card) {
            $card.removeClass('is-open');
            $card.find(selectors.body).attr('hidden', true);
            $card.find(selectors.toggleButton).attr('aria-expanded', 'false');
        }

        function openCard($card) {
            $addressSection.find(selectors.card).not($card).each(function () {
                closeCard($(this));
            });

            $card.addClass('is-open');
            $card.find(selectors.body).removeAttr('hidden');
            $card.find(selectors.toggleButton).attr('aria-expanded', 'true');

            var $firstInput = $card.find('input[type="text"], select').filter(':visible').first();
            if ($firstInput.length) {
                $firstInput.trigger('focus');
            }
        }

        function setDirtyState($card, isDirty) {
            $card.attr('data-is-dirty', isDirty ? '1' : '0');
            $card.toggleClass('is-dirty', isDirty);
        }

        function setSavingState($card, isSaving) {
            $card.toggleClass('is-saving', isSaving);
            $card.find('button, input, select').prop('disabled', isSaving);
            $card.find('.save-state').text(isSaving ? user_profile.i18n.saving : '');
        }

        function updateSummary($card, address) {
            let summaryParts = [];

            if (address.city) {
                summaryParts.push(address.city);
            }

            if (address.add_1) {
                summaryParts.push(address.add_1);
            }

            if (address.add_2) {
                summaryParts.push(address.add_2);
            }

            if (address.phone) {
                summaryParts.push(address.phone);
            }

            if (address.country_label) {
                summaryParts.push(address.country_label);
            }

            $card.attr('data-address-id', address.id);
            $card.attr('data-is-new', '0');
            $card.removeClass('is-new');

            $card.find('[name="address_id"]').val(address.id);
            $card.find('[name="is_new"]').val('0');
            $card.find('.custom-address-card__name').text(address.name || user_profile.i18n.newAddress);
            $card.find('.custom-address-card__meta').text(summaryParts.join(' · '));

            if (address.is_default) {
                updateDefaultAddressUI(address.id);
            }
        }

        function collectCardData($card) {
            return {
                address_id: $.trim($card.find('[name="address_id"]').val()),
                is_new: $.trim($card.find('[name="is_new"]').val()),
                name: $.trim($card.find('[name="name"]').val()),
                address_1: $.trim($card.find('[name="address_1"]').val()),
                address_2: $.trim($card.find('[name="address_2"]').val()),
                city: $.trim($card.find('[name="city"]').val()),
                postcode: $.trim($card.find('[name="postcode"]').val()),
                phone: $.trim($card.find('[name="phone"]').val()),
                country: $card.find('[name="country"]').val()
            };
        }


        function validateCardData(data) {
            var errors = {};
            var requiredFields = ['name', 'address_1', 'address_2', 'city', 'postcode', 'phone', 'country'];

            $.each(requiredFields, function (_, fieldName) {
                if (!data[fieldName]) {
                    errors[fieldName] = user_profile.i18n.required;
                }
            });

            return errors;
        }

        function createNewCard() {
            var template = $('#custom-address-card-template').html();

            if (!template) {
                return;
            }

            var tempId = 'new_' + Date.now();
            var html = template.replace(/__ADDRESS_ID__/g, tempId);
            var $accordion = $addressSection.find(selectors.accordion);
            var $existingNewCard = $accordion.find(selectors.card + '[data-is-new="1"]');

            if ($existingNewCard.length) {
                openCard($existingNewCard.first());
                return;
            }

            $accordion.find(selectors.emptyState).remove();

            var $newCard = $(html);
            $accordion.prepend($newCard);
            openCard($newCard);
        }

        function saveCard($card) {
            let data = collectCardData($card);
            let clientErrors = validateCardData(data);
            const isNew = data.is_new === '1';

            clearFieldErrors($card);

            if (Object.keys(clientErrors).length > 0) {
                renderFieldErrors($card, clientErrors);
                return;
            }

            setBlockSavingState($card, true);

            $.ajax({
                type: 'post',
                url: user_profile.ajax_url,
                dataType: 'json',
                data: $.extend({}, data, {
                    action: 'vet_save_custom_address',
                    security: user_profile.nonce
                })
            }).done(function (response) {
                if (!response || !response.success || !response.data || !response.data.address) {
                    $card.find('.save-state').text(user_profile.i18n.saveError);
                    return;
                }

                updateSummary($card, response.data.address);
                setDirtyState($card, false);
                clearFieldErrors($card);

                if (isNew) {
                    addCardSetDefaultButton($card);
                }

                setBlockNotice($card, response.data.message || user_profile.i18n.saved, 'success');
            }).fail(function (xhr) {
                var response = xhr.responseJSON;

                if (response && response.data && response.data.field_errors) {
                    renderFieldErrors($card, response.data.field_errors);
                }

                $card.find('.save-state').text(
                    response && response.data && response.data.message
                        ? response.data.message
                        : user_profile.i18n.saveError
                );

                setBlockNotice(
                    response && response.data && response.data.message
                        ? response.data.message
                        : user_profile.i18n.saveError,
                    'error'
                );
            }).always(function () {
                setBlockSavingState($card, false);
            });
        }

        function setDefaultAddress($card) {
            setBlockSavingState($card, true);

            $.ajax({
                type: 'post',
                url: user_profile.ajax_url,
                dataType: 'json',
                data: {
                    action: 'vet_set_default_custom_address',
                    security: user_profile.nonce,
                    address_id: $card.attr('data-address-id')
                }
            }).done(function (response) {
                if (!response || !response.success || !response.data || !response.data.address) {
                    setSectionNotice(user_profile.i18n.saveError, 'error');
                    return;
                }

                updateDefaultAddressUI(response.data.address.id);
                setSectionNotice(response.data.message || user_profile.i18n.defaultUpdated, 'success');
            }).fail(function (xhr) {
                var response = xhr.responseJSON;

                setSectionNotice(
                    response && response.data && response.data.message
                        ? response.data.message
                        : user_profile.i18n.saveError,
                    'error'
                );
            }).always(function () {
                setBlockSavingState($card, false);
            });
        }

        function deleteCard($card) {
            var isNew = $card.attr('data-is-new') === '1';

            if (isNew) {
                $card.remove();

                if (!$addressSection.find(selectors.card).length) {
                    $addressSection.find(selectors.accordion).append(
                        '<div class="custom-addresses-empty">' + user_profile.i18n.empty + '</div>'
                    );
                }

                return;
            }

            if (!window.confirm(user_profile.i18n.deleteConfirm)) {
                return;
            }

            $.ajax({
                type: 'post',
                url: user_profile.ajax_url,
                dataType: 'json',
                data: {
                    action: 'vet_delete_custom_address',
                    security: user_profile.nonce,
                    address_id: $card.attr('data-address-id')
                }
            }).done(function (response) {
                if (!response || !response.success) {
                    return;
                }

                $card.remove();

                if (!$addressSection.find(selectors.card).length) {
                    $addressSection.find(selectors.accordion).append(
                        '<div class="custom-addresses-empty">' + user_profile.i18n.empty + '</div>'
                    );
                } else {

                    updateDefaultAddressUI(response.data.default_address_id);
                }

                setSectionNotice(response.data.message || user_profile.i18n.deleted, 'success');
            });
        }

        $addressSection.on('click', selectors.addButton, function () {
            createNewCard();
        });

        $addressSection.on('click', selectors.toggleButton, function () {
            var $card = $(this).closest(selectors.card);

            if ($card.hasClass('is-open')) {
                closeCard($card);
                return;
            }

            openCard($card);
        });

        $addressSection.on('click', selectors.cancelButton, function () {
            var $card = $(this).closest(selectors.card);
            var isNew = $card.attr('data-is-new') === '1';
            var isDirty = $card.attr('data-is-dirty') === '1';

            if (isDirty && !window.confirm(user_profile.i18n.discardConfirm)) {
                return;
            }

            if (isNew) {
                $card.remove();

                if (!$addressSection.find(selectors.card).length) {
                    $addressSection.find(selectors.accordion).append(
                        '<div class="custom-addresses-empty">' + user_profile.i18n.empty + '</div>'
                    );
                }

                return;
            }

            clearFieldErrors($card);
            closeCard($card);
        });

        $addressSection.on('click', selectors.saveButton, function () {
            saveCard($(this).closest(selectors.card));
        });

        $addressSection.on('click', selectors.deleteButton, function () {
            deleteCard($(this).closest(selectors.card));
        });

        $addressSection.on('click', selectors.setDefaultButton, function () {
            setDefaultAddress($(this).closest(selectors.card));
        });

        $addressSection.on('input change', selectors.card + ' input, ' + selectors.card + ' select', function () {
            setDirtyState($(this).closest(selectors.card), true);
        });
    }

    $form.on('click', '.save-account-block[data-save-block="user-info"]', function () {
        saveUserInfoBlock( $(this).closest('[data-account-block="user-info"]') );
    });

    const VetfondsUserProfileAddress = {
        form: $('form.edit-account'),
        vatPayerCheckbox: $('#company_vat_payer'),
        // New production-ready cached selectors inside the form context
        personRadioSelector: '.radio-buttons input[type="radio"]',
        companyInfo: $('.woocommerce-EditAccountForm .company-info'),
        billingAddress: $('.woocommerce-EditAccountForm .billing-address-block'),
        hideBlockClass: 'hide-block',

        boot: function() {
            // Run initial states on page load
            this.toggleCompanyVatNrField();
            this.toggleCompanyFields();

            // Initialize event listeners
            this.initLegalPersonVatCheckboxListener();
            this.initAccountTypeRadioListener();
        },

        toggleCompanyVatNrField: function() {
            const $this = VetfondsUserProfileAddress;

            if ($this.vatPayerCheckbox.is(':checked')) {
                $this.form.find('#company_vat_nr').parent().parent().removeClass('hide');
            } else {
                $this.form.find('#company_vat_nr').parent().parent().addClass('hide');
            }
        },

        /**
         * Toggles visibility for corporate vs individual layout blocks
         */
        toggleCompanyFields: function() {
            console.log('toggleCompanyFields');
            const $this = VetfondsUserProfileAddress;

            // Find the currently checked radio button inside the form
            const selectedValue = $this.form.find($this.personRadioSelector).filter(':checked').val();

            if (selectedValue === 'individual') {
                $this.companyInfo.addClass($this.hideBlockClass);
                $this.billingAddress.removeClass($this.hideBlockClass);
            } else {
                $this.billingAddress.addClass($this.hideBlockClass);
                $this.companyInfo.removeClass($this.hideBlockClass);
            }
        },

        initLegalPersonVatCheckboxListener: function() {
            const $this = VetfondsUserProfileAddress;

            $this.vatPayerCheckbox.on('change', function() {
                $this.toggleCompanyVatNrField();
            });
        },

        /**
         * Initializes a delegated change listener for the account type radio buttons
         */
        initAccountTypeRadioListener: function() {
            const $this = VetfondsUserProfileAddress;

            // Delegating to $this.form to handle potential WooCommerce AJAX refreshes safely
            $this.form.on('change', $this.personRadioSelector, function() {
                $this.toggleCompanyFields();
            });
        }
    };

    VetfondsUserProfileAddress.boot()
});